import {apiClient} from '@common/http/query-client';
import {useMutation} from '@tanstack/react-query';
import { UpdatePlayTimeRequest } from './types';

export const useUpdatePlayerWatchTime = () => {
  return useMutation({
    mutationKey: ['update-play-time'],
    mutationFn: (data: UpdatePlayTimeRequest) => updatePlayerWatchTime(data),
  });
};

const updatePlayerWatchTime = (data: UpdatePlayTimeRequest) => {
  return apiClient.post('stream/store', data).then(r => r.data);
};
